(() => {
  const source = document.currentScript;
  const labels = Object.fromEntries(['play', 'pause', 'close', 'loading', 'error', 'youtube'].map(key => [key, source?.dataset[key] || key]));
  let ready;
  let current;
  const playIcon = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M8 5v14l11-7z"/></svg>';
  const pauseIcon = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M6 5h4v14H6zm8 0h4v14h-4z"/></svg>';
  const resetButton = button => {
    button.innerHTML = playIcon;
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', labels.play + ' ' + button.dataset.trackTitle);
  };
  const close = () => {
    if (!current) return;
    const old = current;
    current = null;
    old.observer?.disconnect();
    old.player?.destroy();
    old.row.remove();
    resetButton(old.button);
  };
  const api = () => {
    if (window.YT?.Player) return Promise.resolve();
    if (ready) return ready;
    ready = new Promise((resolve, reject) => {
      const previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        previous?.();
        resolve();
      };
      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api';
      script.async = true;
      script.onerror = reject;
      document.head.append(script);
    });
    return ready;
  };
  const open = async (button, track) => {
    if (current?.button === button && current.player) {
      if (current.player.getPlayerState() === 1) current.player.pauseVideo();
      else current.player.playVideo();
      return;
    }
    close();
    const row = document.createElement('li');
    row.className = 'hug-track-player-row';
    const header = document.createElement('div');
    header.className = 'hug-track-player-header';
    const title = document.createElement('strong');
    title.textContent = button.dataset.trackTitle;
    const dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.className = 'hug-track-player-close';
    dismiss.textContent = '×';
    dismiss.setAttribute('aria-label', labels.close);
    dismiss.addEventListener('click', () => {
      close();
      button.focus();
    });
    header.append(title, dismiss);
    const frame = document.createElement('div');
    frame.className = 'hug-track-player-frame';
    const mount = document.createElement('div');
    frame.append(mount);
    const status = document.createElement('p');
    status.className = 'hug-track-player-status';
    status.setAttribute('role', 'status');
    status.textContent = labels.loading;
    const youtube = document.createElement('a');
    youtube.href = 'https://www.youtube.com/watch?v=' + encodeURIComponent(track.dataset.youtube);
    youtube.target = '_blank';
    youtube.rel = 'noopener';
    youtube.textContent = labels.youtube;
    row.append(header, frame, status, youtube);
    track.after(row);
    row.scrollIntoView({block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    const active = {button, row, player: null};
    current = active;
    try {
      await api();
      if (current !== active) return;
      const iframe = document.createElement('iframe');
      iframe.title = button.dataset.trackTitle + ' – YouTube';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      const params = new URLSearchParams({enablejsapi: '1', autoplay: '0', playsinline: '1', rel: '0', origin: location.origin, widget_referrer: location.origin + location.pathname});
      iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(track.dataset.youtube) + '?' + params;
      mount.replaceWith(iframe);
      active.player = new YT.Player(iframe, {
        width: '100%',
        height: '100%',
        videoId: track.dataset.youtube,
        playerVars: {autoplay: 0, playsinline: 1, rel: 0, origin: location.origin},
        events: {
          onReady: event => {
            if (current !== active) return;
            status.textContent = '';
            active.observer = new IntersectionObserver(entries => {
              if (current !== active) return;
              if (entries.some(entry => entry.isIntersecting && entry.intersectionRatio > 0.5)) {
                active.observer.disconnect();
                event.target.playVideo();
              }
            }, {threshold: [0.55]});
            active.observer.observe(frame);
          },
          onStateChange: event => {
            if (current !== active) return;
            const playing = event.data === 1;
            button.innerHTML = playing ? pauseIcon : playIcon;
            button.setAttribute('aria-pressed', String(playing));
            button.setAttribute('aria-label', (playing ? labels.pause : labels.play) + ' ' + button.dataset.trackTitle);
          },
          onError: () => { status.textContent = labels.error; }
        }
      });
    } catch {
      if (current === active) status.textContent = labels.error;
    }
  };
  const init = () => {
    document.querySelectorAll('.hug-album-tracks li[data-youtube]').forEach(track => {
      if (track.querySelector('.hug-track-play')) return;
      const title = track.querySelector('.hug-track-title')?.firstChild?.textContent?.trim() || track.querySelector('a')?.textContent?.trim();
      const button = document.createElement('button');
      button.className = 'hug-track-play';
      button.type = 'button';
      button.dataset.trackTitle = title;
      resetButton(button);
      button.addEventListener('click', () => open(button, track));
      track.prepend(button);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
  addEventListener('pagehide', close);
})();
